import { Controller } from '@hotwired/stimulus';
import Swiper, { Navigation } from 'swiper/swiper-bundle.min.js';

export default class extends Controller {
  static targets = ['prev', 'next'];
  connect() {
    Swiper.use([Navigation]);
    new Swiper(this.element, {
      slidesPerView: 1,
      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
    });
  }
}
